import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ec747cb")

_pushScopeId("data-v-3ec747cb")
const _hoisted_1 = { class: "toc_loopCarVideo_main" }
const _hoisted_2 = { class: "toc_loopCarVideo_body" }
const _hoisted_3 = { class: "toc_loopCarVideo_body_cont" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "comTitle_main" }, [
  /*#__PURE__*/_createVNode("div", { class: "comTitle_left" }, "Видеообзор автомобиля")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "video-grid"
}
const _hoisted_6 = { class: "video-cover" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "video-play-icon" }, null, -1)
const _hoisted_8 = { class: "video-name" }
const _hoisted_9 = {
  key: 0,
  class: "video-modal"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetectPlayer = _resolveComponent("DetectPlayer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.state.videoInfo && _ctx.state.videoInfo.length)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.videoInfo, (video, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: video.videoCode,
                  class: "video-item",
                  onClick: ($event: any) => (_ctx.switchTab(index))
                }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("img", {
                      src: video.videoFirstImg,
                      alt: video.videoName
                    }, null, 8, ["src", "alt"]),
                    _hoisted_7
                  ]),
                  _createVNode("div", _hoisted_8, _toDisplayString(video.videoName), 1)
                ], 8, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.state.showVideoModal)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode(_component_DetectPlayer, {
            ref: "videoPlayerRef",
            class: "video-modal_player",
            "play-data": _ctx.state.playData,
            onPlayerEvent: _ctx.onPlayerEvent
          }, null, 8, ["play-data", "onPlayerEvent"]),
          _createVNode("span", {
            class: "video-modal_close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeVideoModal && _ctx.closeVideoModal(...args)))
          })
        ]))
      : _createCommentVNode("", true)
  ]))
})